import type { ResponsiveImageType } from 'react-datocms'
import styled from 'styled-components'

import { TrackedLink } from '@/components/shared/TrackedLink'

import { DatoImage } from '@/elements/global/DatoImage'

/** The article fields the card renders; shared with the lists that render it. */
export type ArticleCardArticle = {
  id?: string
  _firstPublishedAt?: string
  articleSlug?: string
  articleTitle?: string
  abstract: string
  featuredImage: { responsiveImage: ResponsiveImageType | null }
  square?: { responsiveImage: ResponsiveImageType | null }
}

type ArticleCardProps = {
  article: ArticleCardArticle
  className?: string
  firstFeatured?: boolean
}

const StyledArticleCard = styled.div`
  text-align: left;
  a {
    color: ${(props) => props.theme.v2.onSurface.text};
  }
  p {
    margin: 12px 0 0;
    padding: 0;
  }
  h3 {
    margin: 12px 0 0;
  }
  img {
    border-radius: 8px;
    object-fit: cover;
  }
`
export const ArticleCard = ({ article, className, firstFeatured }: ArticleCardProps) => {
  return (
    <StyledArticleCard className={className}>
      <TrackedLink href={`/learn/${article.articleSlug}`} passHref>
        {!firstFeatured ? (
          article.featuredImage.responsiveImage && <DatoImage data={article.featuredImage.responsiveImage} />
        ) : (
          <>
            {article.square?.responsiveImage && <DatoImage data={article.square.responsiveImage} className="desktop" />}
            {article.featuredImage.responsiveImage && (
              <DatoImage data={article.featuredImage.responsiveImage} className="mobile" />
            )}
          </>
        )}
        <h3>{article.articleTitle}</h3>
        {firstFeatured ? (
          <p className="small secondary">{article.abstract.split(' ').splice(0, 30).join(' ')}...</p>
        ) : (
          <p className="small secondary">{article.abstract.split(' ').splice(0, 12).join(' ')}...</p>
        )}
      </TrackedLink>
    </StyledArticleCard>
  )
}
